import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { SearchBox } from "react-google-maps/lib/components/places/SearchBox";
import {
  GoogleMap as GoogleMapPlugin,
  withGoogleMap,
  withScriptjs
} from "react-google-maps";
import mapStyles from "./mapstyle.json";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const inputStyle = {
  boxSizing: `border-box`,
  border: `1px solid transparent`,
  width: `340px`,
  height: `29px`,
  marginTop: `10px`,
  padding: `25px`,
  borderRadius: `5px`,
  boxShadow: `0 2px 35px 0 rgba(0,0,0,0.1)`,
  fontSize: `14px`,
  outline: `none`,
  textOverflow: `ellipsis`
};

class GoogleMapComp extends Component {
  state = {
    bounds: null,
    query: null,
    options: [],
    selected: undefined,
    center: { lng: 4.375212629953012, lat: 50.848313837967936 },
    zoom: null
  };

  onSelectItem = index => {
    const selected = this.state.options[index];
    this.setState({
      selected,
      center: selected.center
    });
  };

  handleChange = option => {
    this.onSelectItem(0);
  };

  handleInputChange = query => {
    if (this.state.query !== query) {
      this.setState({ query });
      this.fetchLocation(query);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { query } = this.props;
    if (query !== prevProps.query) {
      this.updateMapLocation();
    }
  }

  componentDidMount() {
    const { initialBounds } = this.props;
    if (initialBounds) {
      const bounds = new window.google.maps.LatLngBounds();
      initialBounds.forEach(b => {
        bounds.extend(new window.google.maps.LatLng(b.lat, b.lng));
      });
      this.map.fitBounds(bounds);
      setTimeout(() => {
        this.setState({
          bounds: this.map.getBounds(),
          center: this.map.getCenter(),
          zoom: this.map.getZoom()
        });
      }, 500);
    }
  }

  updateMapLocation() {
    const { query, viewport } = this.props;
    const map = this.map;
    if (query && map) {
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { address: query, region: ".be" },
        function(results, status) {
          if (!this.map) return;
          const place = results && results[0];
          if (place && status === window.google.maps.GeocoderStatus.OK) {
            this.map.fitBounds(place.geometry.viewport);
            //  console.log(this.map.getZoom());

            //  this.map.setZoom(this.map.getZoom() + 3);
            this.setState({
              bounds: this.map.getBounds(),
              center: this.map.getCenter(),
              zoom: this.map.getZoom() + 2
            });
          } else if (viewport) {
            const bounds = new window.google.maps.LatLngBounds();
            const {
              viewport_ne_lat,
              viewport_ne_lng,
              viewport_sw_lat,
              viewport_sw_lng
            } = viewport;

            bounds.extend(
              new window.google.maps.LatLng(viewport_ne_lat, viewport_ne_lng)
            );
            bounds.extend(
              new window.google.maps.LatLng(viewport_sw_lat, viewport_sw_lng)
            );

            this.map.fitBounds(bounds);

            this.setState({
              bounds: this.map.getBounds(),
              center: this.map.getCenter(),
              zoom: this.map.getZoom() + 2
            });
          }
        }.bind(this)
      );
    } else if (viewport && map) {
      const bounds = new window.google.maps.LatLngBounds();
      const {
        viewport_ne_lat,
        viewport_ne_lng,
        viewport_sw_lat,
        viewport_sw_lng
      } = viewport;

      bounds.extend(
        new window.google.maps.LatLng(viewport_ne_lat, viewport_ne_lng)
      );
      bounds.extend(
        new window.google.maps.LatLng(viewport_sw_lat, viewport_sw_lng)
      );

      this.map.fitBounds(bounds);

      this.setState({
        bounds: this.map.getBounds(),
        center: this.map.getCenter(),
        zoom: this.map.getZoom() + 2
      });
    }
  }

  onBoundsChanged = () => {
    if (!this.state.bounds) {
      this.updateMapLocation();
    } else {
      this.setState({
        bounds: this.map.getBounds(),
        center: this.map.getCenter(),
        zoom: this.map.getZoom()
      });
    }
  };

  onSearchBoxMounted = ref => {
    this.searchBox = ref;
  };

  searchBox = null;

  onPlacesChanged = (places = this.searchBox.getPlaces()) => {
    const bounds = new window.google.maps.LatLngBounds();
    const place = places[0];
    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }

    this.setState({
      center: places[0].geometry.location
    });
    this.map.fitBounds(bounds);

    if (this.props.onSelect) {
      const { lat, lng } = places[0].geometry.location;
      this.props.onSelect({ lat: lat(), lng: lng() });
    }
  };

  onClick(ev) {
    const { onSelect } = this.props;
    if (onSelect) {
      const { lat, lng } = ev.latLng;
      onSelect({ lat: lat(), lng: lng() });
    }
  }

  map = null;

  render() {
    const { bounds, zoom } = this.state;
    const {
      defaultOptions,
      defaultCenter,
      defaultZoom,
      enableSearchBox,
      children,
      city
    } = this.props;

    return (
      <Wrapper>
        <GoogleMapPlugin
          defaultZoom={defaultZoom}
          zoom={zoom}
          defaultCenter={defaultCenter}
          defaultOptions={
            defaultOptions
              ? { styles: mapStyles, ...defaultOptions }
              : { mapTypeControl: false, styles: mapStyles }
          }
          onBoundsChanged={this.onBoundsChanged}
          onClick={(e, f) => this.onClick(e, f)}
          ref={ref => {
            this.map = ref;
          }}
        >
          {children}
        </GoogleMapPlugin>

        {enableSearchBox && (
          <SearchBox
            ref={this.onSearchBoxMounted}
            bounds={bounds}
            controlPosition={2}
            onPlacesChanged={this.onPlacesChanged}
          >
            <input
              type="text"
              placeholder={`Zoek locatie in ${city}`}
              style={inputStyle}
            />
          </SearchBox>
        )}
      </Wrapper>
    );
  }
}

GoogleMapComp.propTypes = {
  defaultCenter: PropTypes.object,

  query: PropTypes.string,
  children: PropTypes.any,
  enableSearchBox: PropTypes.bool,
  defaultZoom: PropTypes.number,
  onPlacesChanged: PropTypes.func,
  onDblClick: PropTypes.func
};

const GoogleMapWithScripts = withScriptjs(
  withGoogleMap(props => (
    <GoogleMapComp
      defaultZoom={8}
      defaultCenter={{ lng: 4.375212629953012, lat: 50.848313837967936 }}
      {...props}
    />
  )),
  {}
);

const MapWrapper = props => {
  return (
    <GoogleMapWithScripts
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCzDDU6UV_V-oRK3JSUHLAHG5ZvX2JLn9g&v=3.exp&libraries=geometry,drawing,places" // eslint-disable-line
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={
        <div
          style={{
            height: props.height ? props.height : `300px`,
            width: "100%"
          }}
        />
      }
      mapElement={<div style={{ height: `100%`, width: "100%" }} />}
      {...props}
    />
  );
};

MapWrapper.propTypes = {
  height: PropTypes.any
};

export default MapWrapper;



// WEBPACK FOOTER //
// ./src/components/MapWrapper/MapWrapper.js